import axios from 'axios'
import { calendarQuery, eventsCategoriesQuery } from '../events/queries.gql'
import { staffDirectoryQuery, staffDirectoryCategoriesQuery } from '../staffDirectory/queries.gql'
import { notificationsQuery } from './../notifications/queries.gql'

const GRAPHQL_CLIENT_SECRET = process.env.GRAPHQL_CLIENT_SECRET

const gqlClient = axios.create({
  baseURL: '/gql',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${GRAPHQL_CLIENT_SECRET}`
  }
})

export default {
  getEventsCategories (variables) {
    return gqlClient.post('', {
      query: eventsCategoriesQuery,
      variables: variables
    })
  },
  getEvents (variables) {
    return gqlClient.post('', {
      query: calendarQuery,
      variables: variables
    })
  },
  getStaffCategories () {
    return gqlClient.post('', {
      query: staffDirectoryCategoriesQuery
    })
  },
  getStaff (variables) {
    return gqlClient.post('', {
      query: staffDirectoryQuery,
      variables: variables
    })
  },
  getNotifications (variables) {
    return gqlClient.post('', {
      query: notificationsQuery,
      variables: variables
    })
  }
}
